// ============================================
// LABELS
// ============================================

export const LABELS = {
  fr: {
    overview: "Vue d'ensemble",
    experience: "Expérience",
    skills: "Compétences",
    projects: "Projets",
    cv: "CV PDF",
    contact: "Contact",
    download: "Télécharger en PDF",
    current: "En cours",
    verified: "Vérifié",
    technical_skills: "Compétences Techniques",
    soft_skills: "Soft Skills",
    certifications: "Certifications",
    badges: "Certifications & Badges",
    pipeline: "Pipeline CI/CD",
    running: "En cours",
    languages: "Langages",
    infrastructure: "Infrastructure",
    cloud_tools: "Cloud & Outils",
    profile: "Profil",
    print_version: "CV - Version Imprimable",
    cinema: "Popcorn",
    cinema_title: "Cinéma & Séries",
    cinema_subtitle: "Mon activité Trakt.tv",
    top_movies: "Mes films préférés",
    now_watching: "En cours de visionnage",
    nothing_watching: "Rien en cours",
    recently_watched: "Récemment regardé",
    movies: "Films",
    shows: "Séries",
    rated: "noté",
    watched_at: "regardé le",
    configure_trakt: "Configurer Trakt.tv",
    trakt_config_help: "Ajoutez votre Client ID et nom d'utilisateur dans les variables d'environnement",
    view_on_trakt: "Voir sur Trakt.tv →"
  },
  en: {
    overview: "Overview",
    experience: "Experience",
    skills: "Skills",
    projects: "Projects",
    cv: "CV PDF",
    contact: "Contact",
    download: "Download PDF",
    current: "Current",
    verified: "Verified",
    technical_skills: "Technical Skills",
    soft_skills: "Soft Skills",
    certifications: "Certifications",
    badges: "Certifications & Badges",
    pipeline: "CI/CD Pipeline",
    running: "Running",
    languages: "Languages",
    infrastructure: "Infrastructure",
    cloud_tools: "Cloud & Tools",
    profile: "Profile",
    print_version: "CV - Printable Version",
    cinema: "Popcorn",
    cinema_title: "Movies & TV Shows",
    cinema_subtitle: "My Trakt.tv activity",
    top_movies: "My favorite movies",
    now_watching: "Currently watching",
    nothing_watching: "Nothing playing",
    recently_watched: "Recently watched",
    movies: "Movies",
    shows: "TV Shows",
    rated: "rated",
    watched_at: "watched on",
    configure_trakt: "Configure Trakt.tv",
    trakt_config_help: "Add your Client ID and username in environment variables",
    view_on_trakt: "View on Trakt.tv →"
  }
};
